module.exports = __webpack_public_path__ + "../resources/img/ic_complete_number_1_lt.8bf7bbd8.svg";